export default __webpack_public_path__ + "static/media/circle_4.863a1c90.png";